import { customizeCraftJsComponent } from '../../helpers';
import { EditorInput } from '../EditorInput';

export const EditorTenantNameInput = customizeCraftJsComponent(EditorInput, {
	name: 'Tenant Name',
	props: {
		name: 'tenantName',
		placeholder: 'Tenant Name',
		label: 'Tenant Name'
	}
});
